module.exports = __webpack_public_path__ + "static/img/douyin.27304b7f.png";